import React, { ReactNode } from 'react';
import { cn } from '@/utils';

export interface SegmentedControlOption<T> {
  label: ReactNode;
  value: T;
}

interface SegmentedControlProps<T> {
  options: SegmentedControlOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

export function SegmentedControl<T extends string | number>({
  options,
  value,
  onChange,
  className,
}: SegmentedControlProps<T>) {
  const selectedIndex = Math.max(
    0,
    options.findIndex((opt) => opt.value === value)
  );

  return (
    <div
      className={cn(
        'relative inline-flex items-center justify-center p-1 rounded-[12px] border border-[#082261]/50 bg-white shadow-sm overflow-hidden',
        className
      )}
    >
      {/* Sliding Background Pill */}
      <div
        className="absolute left-1 top-1 bottom-1 rounded-[8px] bg-[linear-gradient(to_right,#082261,#34065c)] transition-transform duration-300 ease-in-out shadow inner-shadow-blue"
        style={{
          width: `calc((100% - 8px) / ${options.length})`,
          transform: `translateX(calc(${selectedIndex * 100}%))`,
        }}
      />
      {options.map((option) => (
        <button
          key={String(option.value)}
          onClick={() => onChange(option.value)}
          className={cn(
            'relative z-10 h-10 px-6 flex-1 flex items-center justify-center rounded-[8px] font-spectral font-semibold uppercase transition-colors duration-300 font-14 sm:w-auto min-w-[180px]',
            value === option.value ? 'text-white' : 'text-[#082261] hover:bg-[#082261]/5'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
